import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("lumiar_user")); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("lumiar_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      localStorage.setItem("lumiar_user", JSON.stringify(r.data));
    }).catch(() => {
      localStorage.removeItem("lumiar_token");
      localStorage.removeItem("lumiar_user");
      setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("lumiar_token", r.data.token);
    localStorage.setItem("lumiar_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  // Step 1 of OTP signup. Returns { pending_id, email, dev_otp, expires_in_minutes }.
  const signup = async (payload) => {
    const r = await api.post("/auth/signup/init", payload);
    return r.data;
  };

  // Step 2 callback after /auth/signup/verify succeeds.
  const completeSignup = (token, userObj) => {
    localStorage.setItem("lumiar_token", token);
    localStorage.setItem("lumiar_user", JSON.stringify(userObj));
    setUser(userObj);
  };

  const logout = () => {
    localStorage.removeItem("lumiar_token");
    localStorage.removeItem("lumiar_user");
    setUser(null);
    window.location.href = "/";
  };

  const refresh = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    localStorage.setItem("lumiar_user", JSON.stringify(r.data));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, completeSignup, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
